// Runtime hostname overrides — allows a single build to serve multiple environments
const getHostnameConfig = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  if (hostname === 'zfsuperadmin.zonkasurvey.com') {
    // Nightly environment
    return {
      APP_ENV: 'nightly',
      ADMIN_API_URL: 'https://admin-us1.zonkasurvey.com/api/v1/superadmin',
      BACKEND_URL_US: 'https://us1.zonkasurvey.com',
      BACKEND_URL_EU: 'https://us1.zonkasurvey.com',
      BACKEND_URL_IN: 'https://us1.zonkasurvey.com',
      BACKEND_URL_AU: 'https://us1.zonkasurvey.com',
      PUBLIC_API_URL: 'https://cgomglpili.execute-api.us-east-2.amazonaws.com/Nightly',
    };
  }

  return null;
};

const hostnameConfig = getHostnameConfig();

const env = {
  APP_ENV: hostnameConfig?.APP_ENV ?? import.meta.env.VITE_APP_ENV ?? 'development',
  ADMIN_API_URL: hostnameConfig?.ADMIN_API_URL ?? import.meta.env.VITE_ADMIN_API_URL ?? 'http://localhost:4050/api/v1/superadmin',
  BACKEND_URL_US: hostnameConfig?.BACKEND_URL_US ?? import.meta.env.VITE_BACKEND_URL_US ?? '',
  BACKEND_URL_EU: hostnameConfig?.BACKEND_URL_EU ?? import.meta.env.VITE_BACKEND_URL_EU ?? '',
  BACKEND_URL_IN: hostnameConfig?.BACKEND_URL_IN ?? import.meta.env.VITE_BACKEND_URL_IN ?? '',
  BACKEND_URL_AU: hostnameConfig?.BACKEND_URL_AU ?? import.meta.env.VITE_BACKEND_URL_AU ?? '',
  PUBLIC_API_URL: hostnameConfig?.PUBLIC_API_URL ?? import.meta.env.VITE_PUBLIC_API_URL ?? '',
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  LINKEDIN_CLIENT_ID: import.meta.env.VITE_LINKEDIN_CLIENT_ID || '',
  MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN || '',
  BUILDER_URL: import.meta.env.VITE_BUILDER_URL || '',
  TEMPLATE_URL: import.meta.env.VITE_TEMPLATE_URL || '',
  ACCESS_ACCOUNT_URL: import.meta.env.VITE_ACCESS_ACCOUNT_URL || '',
  HUBSPOT_ID: import.meta.env.VITE_HUBSPOT_ID || '',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
};

export const REGION_URLS = {
  US: env.BACKEND_URL_US,
  EU: env.BACKEND_URL_EU,
  IN: env.BACKEND_URL_IN,
  AU: env.BACKEND_URL_AU,
} as const;

export type Region = keyof typeof REGION_URLS;

export default env;
